<app-page-title titleHeading='Cards examples 8' titleDescription='Wide selection of cards with multiple styles, borders, actions and hover effects.'></app-page-title>

<app-example-wrapper-seamless sectionHeading="Cards 49">
    <app-cards8-examples-49></app-cards8-examples-49>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 50">
    <app-cards8-examples-50></app-cards8-examples-50>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 51">
    <app-cards8-examples-51></app-cards8-examples-51>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 52">
    <app-cards8-examples-52></app-cards8-examples-52>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 53">
    <app-cards8-examples-53></app-cards8-examples-53>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 54">
    <app-cards8-examples-54></app-cards8-examples-54>
</app-example-wrapper-seamless>
<app-example-wrapper-seamless sectionHeading="Cards 55">
    <app-cards8-examples-55></app-cards8-examples-55>
</app-example-wrapper-seamless>

